import React from "react";
import Textfield from "../Textfield/Textfield";
import PrimaryButton from "../Buttons/PrimaryButton";
import styles from "./SearchCard.module.scss";

const SearchCard = ({
  tabs,
  activeCard,
  setActiveCard,
  config,
  values,
  handleChange,
  errors,
  touched,
  handleBlur,
  isLoading,
}) => {
  const getSliderPosition = () => {
    const index = tabs.findIndex((t) => t.key === activeCard);
    return index === -1 ? 0 : index;
  };
  const currentTab = tabs.find((t) => t.key === activeCard);
  const sliderClassName = [
    styles.slider,
    styles[`sliderPosition${getSliderPosition()}`],
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={styles.wrapper}>
      <div className={styles.tabHeader}>
        {tabs.map((tab) => {
          const isEnabled = config?.[tab.key];

          return (
            <div
              key={tab.key}
              className={`${styles.tabItem}
          ${activeCard === tab.key ? styles.active : ""}
          ${!isEnabled ? styles.disabled : ""}`}
              onClick={() => isEnabled && setActiveCard(tab.key)}
            >
              {tab.label}
            </div>
          );
        })}

        {activeCard && <div className={sliderClassName} />}
      </div>

      <div className={styles.content}>
        {activeCard && config?.[activeCard] && (
          <>
            <Textfield
              name={activeCard}
              label={currentTab?.placeholder}
              value={values[activeCard]}
              handleOnChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(errors?.[activeCard])}
              helperText={errors?.[activeCard]}
            />

            <div className={styles.actionWrapper}>
              <PrimaryButton type="submit" isLoading={isLoading} fullWidth>
                Search User
              </PrimaryButton>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SearchCard;
